import type { OpenAPIConfig } from '@forest/fetch';

import { ADMIN_API_ORIGIN } from '@/config';

export const APIConfig: OpenAPIConfig = {
  BASE: ADMIN_API_ORIGIN,
  VERSION: '0.0.1',
  WITH_CREDENTIALS: true,
  CREDENTIALS: 'include',
  USERNAME: undefined,
  PASSWORD: undefined,
  HEADERS: undefined,
  ENCODE_PATH: undefined,
};

export const S3APIConfig: OpenAPIConfig = {
  ...APIConfig,
  BASE: '',
  CREDENTIALS: 'omit',
  TOKEN: undefined,
};
